module.exports = __webpack_public_path__ + "static/media/balizas-v16.7e766603.webp";